// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icone-pequeno {font-size: 13px;}\n.icone-grande {font-size: 18px;}\n.icone-1x {font-size: 1em;}\n.icone-2x {font-size: 2em;}\n.icone-3x {font-size: 3em;}\n.icone-4x {font-size: 4em;}\n.icone-5x {font-size: 5em;}\n.icone-6x {font-size: 6em;}\n.icone-7x {font-size: 7em;}\n.icone-8x {font-size: 8em;}\n.icone-9x {font-size: 9em;}\n.icone-10x {font-size: 10em;}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
